var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSvgBlogTwitter = function SvgSvgBlogTwitter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.683 1.688h2.482l-5.421 6.194 6.377 8.43h-4.992l-3.913-5.111-4.472 5.111H1.26l5.797-6.626L.942 1.688h5.119L9.594 6.36l4.089-4.673Zm-.872 13.14h1.374L5.313 3.095H3.835l8.976 11.735Z",
    fill: "currentColor"
  })));
};
export default SvgSvgBlogTwitter;